import React, {useEffect} from "react";

import {useInteractiveGeoJson, UseInteractiveGeoJsonOptions} from "../hooks/use_interactive_geo_json";

export interface IInteractiveGeoJsonLayerProps extends UseInteractiveGeoJsonOptions {
    onSelectionChange?: (selectedFeatures: (string | number)[]) => void;
}

export const InteractiveGeoJsonLayer = (props: IInteractiveGeoJsonLayerProps) => {
    const {selectedFeatures} = useInteractiveGeoJson(props);

    useEffect(() => {
        props.onSelectionChange?.(selectedFeatures);
    }, [selectedFeatures, props.onSelectionChange]);

    return null;
};
